@if (visible()) {
  @if (!floatingPresence()) {
    <div class="pwp-info-bar cms-content placeholder-bar" data-automation="pwp-placeholder"></div>
  } @else {
  <div
    class="pwp-info-bar cms-content"
    [class.expanded]="expanded()"
    [attr.data-automation]="expanded() ? 'my-max' : 'my-min'"
  >
    @if (!expanded()) {
      <!-- Collapsed bar -->
      <button
        type="button"
        class="toggle-btn"
        (click)="toggle()"
        data-automation="maximize"
        [attr.aria-expanded]="expanded()"
        aria-label="Expand shopping associate info"
      >
        <div class="collapsed-content">
          @if (hasValidProfileImage()) {
            <div class="profile-thumb">
              <div
                class="thumb-image"
                data-automation="profile-image-min"
                [style.background-image]="'url(' + floatingPresence()?.params?.['pic']?.value + ')'"
              ></div>
            </div>
          }
          <div class="collapsed-text">
            <span [dotcomTag]="'my-usana.youre-shopping-with'"></span>&nbsp;
            <strong>{{ floatingPresence()?.params?.['name']?.value }}</strong>
          </div>
          <i class="fa-solid fa-chevron-down collapsed-chevron"></i>
        </div>
      </button>
    } @else {
      <!-- Collapse toggle at top -->
      <button
        type="button"
        class="toggle-btn collapse-toggle"
        (click)="toggle()"
        data-automation="minimize-top"
        [attr.aria-expanded]="expanded()"
        aria-label="Collapse shopping associate info"
      >
        <i class="fa-solid fa-chevron-up"></i>
      </button>

      <!-- Expanded view -->
      <div class="expanded-container">
        <!-- Shared product action buttons template -->
        <ng-template #productActionButtons let-cssClass>
          <div class="product-buttons" [class]="cssClass">
            <button
              type="button"
              class="u-btn u-style-secondary u-shape-round u-size-large pwp-outlined"
              data-automation="my-add-to-cart"
              (click)="addAllToCart()"
            >
              <span [dotcomTag]="'my-usana.favorites-add-all-text'"></span>
            </button>

            <a
              class="u-btn u-style-primary-neutral u-shape-round u-size-large"
              [routerLink]="LANDING_ROUTE"
              data-automation="my-shop"
            >
              <span [dotcomTag]="'my-usana.favorites-shop-more-text'"></span>
              <i class="fa-regular fa-arrow-up-right btn-icon"></i>
            </a>
          </div>
        </ng-template>

        <div class="expanded-content">
          <!-- Contact info column -->
          <div class="contact-info">
            <div class="photo-and-name">
              @if (hasValidProfileImage()) {
                <div class="profile-image-wrapper">
                  <div
                    class="profile-image"
                    data-automation="profile-image"
                    [style.background-image]="'url(' + floatingPresence()?.params?.['pic']?.value + ')'"
                  ></div>
                </div>
              }
              <h2 class="associate-name">
                {{ floatingPresence()?.params?.['name']?.value }}
              </h2>
            </div>

            @if (hasAnyContactInfo()) {
              <div class="contact-list">
                <h3 class="contact-heading">
                  <span [dotcomTag]="'my-usana.contact-me'"></span>
                </h3>

                @if (floatingPresence()?.params?.['phone']?.visible) {
                  <a
                    class="contact-item"
                    [href]="'tel:' + floatingPresence()?.params?.['phone']?.value"
                    data-automation="my-phone"
                  >
                    <i class="fa-solid fa-phone contact-icon"></i>
                    <span>{{ floatingPresence()?.params?.['phone']?.value }}</span>
                  </a>
                }

                @if (floatingPresence()?.params?.['email']?.visible) {
                  <a
                    class="contact-item"
                    [href]="'mailto:' + floatingPresence()?.params?.['email']?.value"
                    id="my-email"
                    data-automation="my-email"
                  >
                    <i class="fa-regular fa-envelope contact-icon"></i>
                    <span>{{ floatingPresence()?.params?.['email']?.value }}</span>
                  </a>
                }

                <!-- Social media links -->
                <div class="social-links">
                  @if (floatingPresence()?.params?.['facebook']?.value && floatingPresence()?.params?.['facebook']?.visible) {
                    <a
                      class="social-link"
                      data-automation="my-facebook"
                      [href]="getExternalHref(floatingPresence()?.params?.['facebook']?.value)"
                      rel="noopener"
                      target="_blank"
                      aria-label="Facebook"
                    >
                      <i class="fa-brands fa-facebook"></i>
                    </a>
                  }
                  @if (floatingPresence()?.params?.['instagram']?.value && floatingPresence()?.params?.['instagram']?.visible) {
                    <a
                      class="social-link"
                      data-automation="my-instagram"
                      [href]="getExternalHref(floatingPresence()?.params?.['instagram']?.value)"
                      rel="noopener"
                      target="_blank"
                      aria-label="Instagram"
                    >
                      <i class="fa-brands fa-instagram"></i>
                    </a>
                  }
                  @if (floatingPresence()?.params?.['pinterest']?.value && floatingPresence()?.params?.['pinterest']?.visible) {
                    <a
                      class="social-link"
                      data-automation="my-pinterest"
                      [href]="getExternalHref(floatingPresence()?.params?.['pinterest']?.value)"
                      rel="noopener"
                      target="_blank"
                      aria-label="Pinterest"
                    >
                      <i class="fa-brands fa-pinterest"></i>
                    </a>
                  }
                  @if (floatingPresence()?.params?.['linkedin']?.value && floatingPresence()?.params?.['linkedin']?.visible) {
                    <a
                      class="social-link"
                      data-automation="my-linkedin"
                      [href]="getExternalHref(floatingPresence()?.params?.['linkedin']?.value)"
                      rel="noopener"
                      target="_blank"
                      aria-label="LinkedIn"
                    >
                      <i class="fa-brands fa-linkedin"></i>
                    </a>
                  }
                </div>
              </div>
            }
          </div>

          <!-- Welcome text and product list column -->
          <div class="welcome-and-products">
            <!-- Welcome / My Story section -->
            <div class="welcome-content">
              <div class="welcome-text">
                <h2 class="welcome-heading">
                  <span [dotcomTag]="'my-usana.story-heading' + i18nSuffix()"></span>
                </h2>

                @if (floatingPresence()?.params?.['mystory']?.value) {
                  <div class="welcome-body" data-automation="my-story">
                    {{ floatingPresence()?.params?.['mystory']?.value }}
                  </div>
                } @else {
                  <div class="welcome-body" data-automation="my-story-default">
                    <span [dotcomTag]="'my-usana.story-default' + i18nSuffix()"></span>
                  </div>
                }
              </div>

              <div class="action-buttons">
                @if (floatingPresence()?.params?.['join']?.value === 'true') {
                  <a
                    class="u-btn u-style-secondary u-shape-round u-size-large pwp-outlined"
                    [routerLink]="ENROLL_ASSOCIATE_INFO_ROUTE"
                    data-automation="my-enroll-link"
                  >
                    <span [dotcomTag]="'my-usana.brand-partner-signup-button'"></span>
                  </a>
                }

                <a
                  class="u-btn u-style-link-neutral u-shape-round u-size-large"
                  [routerLink]="ENROLL_PC_INFO_ROUTE"
                  data-automation="pc-upsell-link"
                >
                  <span [dotcomTag]="'my-usana.pc-signup-button'"></span>
                </a>
              </div>
            </div>

            <!-- Product list section -->
            <div class="product-list-section">
              <div class="product-list-header">
                @if (displayFavorites()) {
                  <h2 class="product-list-heading">
                    <span [dotcomTag]="'my-usana.favorites-heading'"></span>
                  </h2>
                } @else {
                  <h2 class="product-list-heading">
                    <span [dotcomTag]="'my-usana.top-selling'"></span>
                  </h2>
                }

                @if (showPricing) {
                  <ng-container
                    [ngTemplateOutlet]="productActionButtons"
                    [ngTemplateOutletContext]="{ $implicit: 'desktop-only' }"
                  ></ng-container>
                }
              </div>

              @if (displayProducts().length > 0) {
                <carousel-wrapper [showArrowsOnMobile]="false" carouselClass="product-carousel">
                  @for (product of displayProducts(); track product.usanaId) {
                    <a
                      class="product-card"
                      [routerLink]="[PRODUCT_ROUTE, ProductUtil.convertUsanaIdToDash(product.usanaId)]"
                      [attr.data-automation]="'my-favorites-' + product.usanaId"
                    >
                      <div class="product-image-wrapper">
                        <img class="product-image" [src]="product.productImages[0]?.imagePath" alt="" />
                      </div>
                      <div class="product-card-body">
                        <div class="product-name" data-automation="featuredProductName">
                          {{ product.productDescription.name }}
                        </div>
                        @if (showPricing) {
                          <div class="product-pricing">
                            <span class="product-price" data-automation="featuredCurrentPrice">{{
                              showPriceByProduct(product)
                            }}</span>
                          </div>
                        }
                      </div>
                    </a>
                  }
                </carousel-wrapper>
              }

              @if (showPricing) {
                <ng-container
                  [ngTemplateOutlet]="productActionButtons"
                  [ngTemplateOutletContext]="{ $implicit: 'mobile-only' }"
                ></ng-container>
              }
            </div>
          </div>
        </div>
      </div>

      <!-- Collapse toggle at bottom -->
      <button
        type="button"
        class="toggle-btn collapse-toggle"
        (click)="toggle()"
        data-automation="minimize"
        [attr.aria-expanded]="expanded()"
        aria-label="Collapse shopping associate info"
      >
        <i class="fa-solid fa-chevron-up"></i>
      </button>
    }
  </div>
  }
}
